import { z } from 'zod'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

const id = z.coerce.number().int().positive().optional().catch(undefined)
export const financeSearchSchema = z.object({
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  ...creatorMemberSearchShape,
  id,
  collectionHeld: z.boolean().optional().catch(undefined),
  organizationId: id,
  customerId: id,
  businessId: id,
  salespersonId: id,
  siteId: id,
  periodFrom: z.iso.date().optional().catch(undefined),
  periodTo: z.iso.date().optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  note: z.string().trim().max(255).optional().catch(undefined),
  occurredFrom: z.iso.datetime({ offset: true }).optional().catch(undefined),
  occurredTo: z.iso.datetime({ offset: true }).optional().catch(undefined),
  status: z.enum(['draft', 'issued', 'pending', 'confirmed', 'voided']).optional().catch(undefined),
  kind: z.enum(['receipt', 'receiptRefund', 'payment', 'paymentRefund']).optional().catch(undefined),
  month: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined)
})
export type FinanceListSearch = z.infer<typeof financeSearchSchema>
export type FinanceListProps = {
  canManage: boolean
  search: FinanceListSearch
  setSearch: (value: FinanceListSearch) => void
}
